// extracted by mini-css-extract-plugin
module.exports = {"FormContainer":"NamesignNotificationFormFields_FormContainer__2IABg","TextArea":"NamesignNotificationFormFields_TextArea__3iNEC"};